import React, { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";

// Custom layout
import MainLayout from "../../../../Layouts/Main";

// styles
import "./styles.scss";

// assets
import assets from "../../../../Assets";

//slice
import {fetchIndividualStaff} from "../../../../Redux/Slices/mainSlice";

const ViewStaff = () => {
    const { id } = useParams()
    const dispatch = useDispatch()
    const navigate = useNavigate()
    const [staffData, setStaffData] = useState(null);

    useEffect(() =>{
        dispatch(
          fetchIndividualStaff({
            data:{
              id:id
            },
            callBack:fetchStaffCB,
          })
        )
      },[id])

      const fetchStaffCB = (data) => {
        console.log(data)
        setStaffData(data.result)
      }

     

  return (
    <MainLayout pageName={"Staff Management"}>
     <div className="goBackDiv" onClick={() => navigate(`/staffManagement`)}>
        <img src={assets.Icons.leftArrow} alt="backIcon" />
        <p>Back to Staff Management</p>
      </div>
      <div className="staff-profile-details">
      <div className="view-staff-container-header">
          <h2>View Staff Details</h2>
        </div>

        <hr style={{ backgroundColor: "#E6E6E6" }} />

        <div className="staff-basic-details-container">
                <h4>Basic details</h4>
                {staffData? (
                <>
                <div className="staff-basic-details-item"><div>Name</div><div>:&nbsp;&nbsp;{staffData.firstname?? "Not Captured"}</div></div>
                <div className="staff-basic-details-item"><div>Mobile Number</div><div>:&nbsp;&nbsp;{staffData.country_code}&nbsp;{staffData.mobile?? "Not Captured"}</div></div>
                <div className="staff-basic-details-item"><div>Email ID</div><div>:&nbsp;&nbsp;{staffData.email?? "Not Captured"}</div></div>
                <div className="staff-basic-details-item"><div>Employee Code</div><div>:&nbsp;&nbsp;{staffData.employee_code ?? "Not Captured"}</div></div>
                {/* <div className="staff-basic-details-item"><div>Industry Name</div><div>:&nbsp;&nbsp;{staffData.industry_name?? "Not Captured"}</div></div>
                <div className="staff-basic-details-item"><div>Sub Industry</div><div>:&nbsp;&nbsp;{staffData.industry_type?? "Not Captured"}</div></div> */}
                </>
                ) : ""}
        </div>
      </div>
    </MainLayout>
  );
};

export default ViewStaff;
